import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import {
  BatchEditItem,
  BatchUpdateItem,
  getallcarsbookingdata,
  getallcleanerslotsdata,
  getallemployeesslotsdata,
  getallexpressslotsdata,
  getallvehicles,
  saveuserdata,
  updateItem,
} from "../../utils/firebasefunctions";
import { IoIosCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import { FaArrowRight, FaUser } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { storage, app } from "../../firebase.config";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { RotatingLines } from "react-loader-spinner";
import ProjectPopUp from "../components/ProjectPopUp";
import StatusPopup from "../components/StatusPopup";
import moment from "moment";
import { FaRegCalendarAlt } from "react-icons/fa";
import DatePicker from "react-horizontal-datepicker";

import { RiPassValidLine } from "react-icons/ri";
import Confirmationpopup from "../components/Confirmationpopup";
import EmployeeSlotPopUp from "../components/EmployeeSlotPopUp";
import { ImFilesEmpty } from "react-icons/im";
import HorizontalDatePicker from "../components/HorizontalDatePicker";
import { IoCheckbox, IoCheckboxOutline } from "react-icons/io5";
import DesignationPopUp from "../components/DesignationPopUp";

const Slots = (props) => {
  const [{ user, clients, employees, notificationslotdata }, dispatch] =
    useStateValue();
  const [checkinstatusfilter, setcheckinstatusfilter] = useState([
    {
      title: "All",
    },
    {
      title: "Pending",
    },
    {
      title: "On The Way",
    },
    {
      title: "Checked In",
    },
    {
      title: "Checked Out",
    },
    {
      title: "Available",
    },
    {
      title: "Available Vehicles",
    },
    {
      title: "Not Accepted",
    },
    {
      title: "Express Delivery",
    },
  ]);
  const daysofweek = [
    {
      day: "Sunday",
    },
    {
      day: "Monday",
    },
    {
      day: "Tuesday",
    },
    {
      day: "Wednesday",
    },
    {
      day: "Thursday",
    },
    {
      day: "Friday",
    },
    {
      day: "Saturday",
    },
  ];
  const [selectedproject, setselectedproject] = useState("All");
  const [selecteddesignations, setselecteddesignations] = useState([]);
  const [designationselectionpopup, setdesignationselectionpopup] =
    useState(false);

  const [selectedprojectdata, setselectedprojectdata] = useState("");
  const [selectedstatus, setselectedstatus] = useState("All");
  const [projectpopup, setprojectpopup] = useState(false);
  const [bulkactionsenabled, setbulkactionsenabled] = useState(false);
  const [bulkeditenabled, setbulkeditenabled] = useState(false);
  const [statuspopup, setstatuspopup] = useState(false);
  const [loading, setloading] = useState(false);
  const [availableemployees, setavailableemployees] = useState([]);
  const [allavailablevehicles, setallavailablevehicles] = useState([]);
  const [selecteddate, setselecteddate] = useState(
    notificationslotdata?.sheduleddate
      ? new Date(notificationslotdata.sheduleddate)
      : new Date(),
  );

  const [startdate, setstartdate] = useState(new Date());
  const [enddate, setenddate] = useState(new Date());
  const [slotdata, setslotdata] = useState([]);
  const [selectedslot, setselectedslot] = useState();
  const [empdetailsvisible, setempdetailsvisible] = useState(false);
  const [bulkactionloader, setbulkactionloader] = useState(false);
  const [selectedshifttype, setselectedshifttype] = useState("Worker");
  const [employeepopup, setemployeepopup] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let startingdate = new Date();
    startingdate.setMonth(startingdate.getMonth() - 3);
    let endingdate = new Date();
    endingdate.setMonth(endingdate.getMonth() + 3);
    setstartdate(startingdate);
    setenddate(endingdate);
  }, []);

  useEffect(() => {
    if (selectedshifttype == "Worker") {
      if (selectedstatus == "Available") {
        getallavailableworkerfortoday();
      } else if (selectedstatus == "Available Vehicles") {
        getallavailablecarsfortoday();
      } else if (selectedstatus == "Express Delivery") {
        getallexpresslotsfortoday();
      } else {
        getallworkerslotsfortoday();
      }
    } else {
      getallcleanerslotsfortoday();
    }
  }, [selecteddate, selectedprojectdata, selectedshifttype, selectedstatus]);

  useEffect(() => {
    if (notificationslotdata?.schedulecreationdate != undefined) {
      console.log(
        "this is the slot data " + JSON.stringify(notificationslotdata),
      );

      let filteredemp = employees.filter(function (data) {
        return data.id == notificationslotdata.employeeid;
      });

      setselectedslot({
        item: notificationslotdata,
        recordid: notificationslotdata.schedulecreationdate.toString(),
        id: filteredemp[0]?.id,
        picture: filteredemp[0]?.profilepicture,
        name: filteredemp[0]?.firstname + " " + filteredemp[0]?.lastname,
        designation: notificationslotdata.projectdesignation,
        phonenumber: filteredemp[0]?.phonenumber,
        starttime: notificationslotdata?.starttime,
        endtime: notificationslotdata?.endtime,
        shifttype: notificationslotdata?.shifttype,
        schedulecreationdate: notificationslotdata?.schedulecreationdate,
        selecteddate: moment(selecteddate).format("YYYY-MM-DD"),
        status: notificationslotdata?.status,
      });
      setempdetailsvisible(true);
      dispatch({
        type: actionType.NotificationSlotData,
        payload: {},
      });
    }
  }, [notificationslotdata]);

  const getallworkerslotsfortoday = async () => {
    let assignedprojects = user?.projectassigned || [];
    let projectidlist = [];
    for (const key in assignedprojects) {
      projectidlist.push(assignedprojects[key].project);
    }

    setloading(true);
    await getallemployeesslotsdata(
      "slots",
      selectedprojectdata?.id,
      moment(selecteddate).format("YYYY-MM-DD"),
      projectidlist,
    )
      .then(async (response) => {
        let dataobj = [...response];
        for (const key in dataobj) {
          dataobj[key]["workerstatus"] = dataobj[key]?.checkoutdatetime
            ? "Checked Out"
            : dataobj[key]?.checkindatetime
              ? "Checked In"
              : dataobj[key]?.onthewaytime
                ? "On The Way"
                : "Pending";
        }

        setslotdata(dataobj);

        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log("err" + err);
      });
  };

  const getallexpresslotsfortoday = async () => {
    let assignedprojects = user?.projectassigned || [];
    let projectidlist = [];
    for (const key in assignedprojects) {
      projectidlist.push(assignedprojects[key].project);
    }

    setloading(true);
    await getallexpressslotsdata(
      "slots",
      selectedprojectdata?.id,
      moment(selecteddate).format("YYYY-MM-DD"),
      projectidlist,
      user.clientrole == true ? user.id : "",
    )
      .then(async (response) => {
        let dataobj = [...response];
        for (const key in dataobj) {
          dataobj[key]["workerstatus"] = dataobj[key]?.checkoutdatetime
            ? "Checked Out"
            : dataobj[key]?.checkindatetime
              ? "Checked In"
              : dataobj[key]?.onthewaytime
                ? "On The Way"
                : dataobj[key]?.employeeid == undefined
                  ? "Pending Supervisor Approval"
                  : "Approved";
        }
        setslotdata(dataobj);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log("err" + err);
      });
  };

  const getallavailableworkerfortoday = async () => {
    let assignedprojects = user?.projectassigned || [];
    let projectidlist = [];
    for (const key in assignedprojects) {
      projectidlist.push(assignedprojects[key].project);
    }

    setloading(true);
    await getallemployeesslotsdata(
      "slots",
      selectedprojectdata?.id,
      moment(selecteddate).format("YYYY-MM-DD"),
      projectidlist,
    )
      .then(async (response) => {
        let dataobj = [...response];
        for (const key in dataobj) {
          dataobj[key]["workerstatus"] = dataobj[key]?.checkoutdatetime
            ? "Checked Out"
            : dataobj[key]?.checkindatetime
              ? "Checked In"
              : dataobj[key]?.onthewaytime
                ? "On The Way"
                : "Pending";
        }

        //////////////////////////

        let busyemployees = [];
        for (const key in dataobj) {
          busyemployees.push({
            id: dataobj[key].employeeid,
          });
        }

        let projectids = [];
        if (selectedprojectdata?.id == "" || selectedprojectdata?.id == null) {
          for (const key in assignedprojects) {
            if (assignedprojects[key].title != "All") {
              projectids.push({
                project: assignedprojects[key].project,
              });
            }
          }
        } else {
          projectids.push({ project: selectedprojectdata?.id });
        }

        console.log("employees length" + employees.length);
        console.log(JSON.stringify(projectids));
        let filteredEmployees = employees.filter((emp) =>
          emp.projectassigned?.find((proj) =>
            projectids?.find((p) => p.project === proj.project),
          ),
        );

        console.log("filteredEmployees length" + filteredEmployees.length);
        const availableEmployees = filteredEmployees.filter(
          (emp) => !busyemployees.find((resEmp) => resEmp.id === emp.id),
        );
        console.log("availableEmployees length" + availableEmployees.length);
        setavailableemployees(availableEmployees);

        ////////////////////////////

        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log("err" + err);
      });
  };

  function diffMinutes(t1, t2, absolute = true) {
    const d1 = new Date(t1).getTime();
    const d2 = new Date(t2).getTime();
    const diffMs = d2 - d1;
    const minutes = diffMs / (1000 * 60);
    return absolute ? Math.abs(Math.round(minutes)) : Math.round(minutes);
  }
  const getallavailablecarsfortoday = async () => {
    let allVehicles = [];

    if (selectedprojectdata?.id == "" || selectedprojectdata?.id == null) {
      allVehicles = Array.from(
        new Set(
          clients
            .filter((item) => Array.isArray(item.vehiclesassigned))
            .flatMap((item) => item.vehiclesassigned),
        ),
      );
    } else {
      if (selectedprojectdata?.vehiclesassigned?.length > 0) {
        allVehicles = [...selectedprojectdata?.vehiclesassigned];
      } else {
        setallavailablevehicles([]);
        return;
      }
    }
    console.log("allVehicles" + JSON.stringify(allVehicles));

    setloading(true);
    await getallcarsbookingdata(
      "TripHistory",
      moment(selecteddate).format("YYYY-MM-DD"),
      allVehicles,
    )
      .then(async (response) => {
        console.log(
          "allVehicles assigned slots that day" + JSON.stringify(response),
        );

        await getallvehicles("vehicles", allVehicles)
          .then(async (innerresponse) => {
            let allavailablevehiclesdata = [...innerresponse];
            for (const key in response) {
              let vehicleindex = allavailablevehiclesdata.findIndex((data) => {
                return data.id == response[key].vehicleid;
              });

              if (vehicleindex != -1) {
                if (allavailablevehiclesdata[vehicleindex].slots == undefined) {
                  allavailablevehiclesdata[vehicleindex]["slots"] = [];
                }
                allavailablevehiclesdata[vehicleindex].slots.push({
                  starttime: response[key].starttime,
                  endtime: response[key].endtime,
                  employeeid: response[key].employeeid,
                  shiftid: response[key].id,
                  timeslot: response[key].timeslot,
                  starttimetimestamp: response[key].starttimetimestamp,
                  endtimetimestamp: response[key].endtimetimestamp,
                });

                if (
                  allavailablevehiclesdata[vehicleindex].totalminutesbooked ==
                  undefined
                ) {
                  allavailablevehiclesdata[vehicleindex]["totalminutesbooked"] =
                    0;
                }
                allavailablevehiclesdata[vehicleindex].totalminutesbooked =
                  allavailablevehiclesdata[vehicleindex].totalminutesbooked +
                  diffMinutes(
                    response[key].starttimetimestamp,
                    response[key].endtimetimestamp,
                  );
              }
            }

            const sortedArray = allavailablevehiclesdata.sort((a, b) => {
              const aMinutes = a.totalminutesbooked;
              const bMinutes = b.totalminutesbooked;

              const aIsUndefined = aMinutes === undefined;
              const bIsUndefined = bMinutes === undefined;

              if (aIsUndefined && bIsUndefined) return 0;
              if (aIsUndefined) return -1;
              if (bIsUndefined) return 1;

              return aMinutes - bMinutes;
            });
            setallavailablevehicles(sortedArray);
            setloading(false);
          })
          .catch((err) => {
            setloading(false);
            console.log(err);
          });
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const getallcleanerslotsfortoday = async () => {
    let assignedprojects = user?.projectassigned || [];
    let projectidlist = [];
    for (const key in assignedprojects) {
      projectidlist.push(assignedprojects[key].project);
    }
    setloading(true);
    await getallcleanerslotsdata(
      "cleaningshifts",
      selectedprojectdata?.id,
      projectidlist,
    )
      .then(async (response) => {
        let responsedata = [...response];
        for (const index in responsedata) {
          responsedata[index]["employeedata"] = [];
          for (const key in responsedata[index].employees) {
            responsedata[index].employeedata.push({
              name: employees
                .filter(function (data) {
                  return data.id == responsedata[index].employees[key];
                })
                .map(function (data) {
                  return data.firstname + " " + data.lastname;
                }),
              profilepicture: employees
                .filter(function (data) {
                  return data.id == responsedata[index].employees[key];
                })
                .map(function (data) {
                  return data.profilepicture;
                }),
            });
          }
        }
        setslotdata(responsedata);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log("err" + err);
      });
  };

  function filters(title, val, onpress) {
    return (
      <div className="w-full md:w-[30%] mt-[20px]">
        <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
          {title}
        </p>
        <div className="relative">
          <div
            onClick={onpress}
            className="input px-4 text-textcolor text-base  PoppinsRegular w-full py-[10px] rounded-md border border-bordercolor items-center  min-h-[40px] bg-themelightblack flex flex-row flex-wrap "
          >
            {title != "Designations"
              ? val
              : selecteddesignations?.length == 0 ||
                  selecteddesignations.find((data) => data.selected == true) ==
                    undefined
                ? "Select Designation"
                : selecteddesignations
                    .filter(function (data) {
                      return data.selected == true;
                    })
                    .map(function (data) {
                      return (
                        <div
                          onClick={() => {
                            let dataset = [...selecteddesignations];
                            const designationindex = dataset.findIndex(
                              (item) => item.designation === data.designation,
                            );
                            dataset[designationindex].selected = false;
                            setselecteddesignations(dataset);
                          }}
                          className=" bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                        >
                          <text className="text-white ">
                            {data.designation}
                          </text>
                          <IoIosCloseCircle className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer" />
                        </div>
                      );
                    })}
          </div>
          <ProjectPopUp
            visible={projectpopup && title == "Projects"}
            data={[...[{ title: "All" }], ...clients]}
            activateoutsidecontainerclick={() => {
              setprojectpopup(false);
            }}
            onClickcorrect={(item) => {
              if (item.title == "All") {
                setselectedproject(item.title);
                setselectedprojectdata("");
                setselecteddesignations([]);
                setprojectpopup(false);
              } else {
                setselecteddesignations([]);
                setselectedproject(item.title);
                setselectedprojectdata(item);
                let data = { ...item };
                if (data?.designation?.length > 0) {
                  for (const key in data.designation) {
                    data.designation[key]["selected"] = false;
                  }
                  setselecteddesignations(data?.designation);
                }

                setprojectpopup(false);
              }
            }}
          />

          <DesignationPopUp
            bulkaction={(status) => {
              let data = [...selecteddesignations];
              const updatedArray = data.map((item) => ({
                ...item,
                selected: status,
              }));
              setselecteddesignations(updatedArray);
            }}
            multi={true}
            visible={designationselectionpopup && title == "Designations"}
            data={selecteddesignations}
            activateoutsidecontainerclick={() => {
              setdesignationselectionpopup(false);
            }}
            onClick={(item, index) => {
              let data = [...selecteddesignations];
              data[index].selected = !data[index].selected;
              //         data.designation[index].selected = !data.designation[index].selected
              // setproject(data)
              setselecteddesignations(data);
            }}
          />
          <StatusPopup
            visible={statuspopup && title == "Status"}
            data={checkinstatusfilter}
            activateoutsidecontainerclick={() => {
              setstatuspopup(false);
            }}
            onClickcorrect={(item) => {
              setselectedstatus(item.title);
              setstatuspopup(false);
            }}
          />
        </div>
      </div>
    );
  }

  function todaysdate() {
    return (
      <div className="flex flex-row w-full items-center justify-center relative">
        <div className="flex flex-row w-full items-center justify-start relative">
          <div>
            <FaRegCalendarAlt className="text-[30px] text-textcolor" />
          </div>
          <div className="ml-[5px]">
            <p className="PoppinsRegular  text-textcolor text-sm">
              {moment(new Date()).format("DD MMM yyyy")}
            </p>
            <p className="PoppinsRegular  text-lightgrey text-sm">
              {daysofweek[moment(new Date()).day()].day}
            </p>
          </div>
        </div>
        <img
          loading="lazy"
          src={user.profilepicture}
          className="position absolute h-[120px] w-[120px] rounded-full object-cover top-[-80px]"
        />
      </div>
    );
  }

  const selectedDay = (val) => {
    setselecteddate(val);
  };

  async function bulkaction(type) {
    setbulkactionloader(true);

    if (type == "reset") {
      let filtereddata = slotdata.filter((item) => item.editselected == true);

      for (const key in filtereddata) {
        let checkindatetime = filtereddata[key].starttimetimestamp;
        let checkintime = moment(filtereddata[key].starttimetimestamp).format(
          "HH:mm",
        );

        let checkoutdatetime = filtereddata[key].endtimetimestamp;
        let checkouttime = moment(filtereddata[key].endtimetimestamp).format(
          "HH:mm",
        );

        filtereddata[key]["checkindate"] =
          moment(checkindatetime).format("YYYY-MM-DD");
        filtereddata[key]["checkindatetime"] = checkindatetime;
        filtereddata[key]["checkintime"] = checkintime;

        filtereddata[key]["checkoutdate"] =
          moment(checkoutdatetime).format("YYYY-MM-DD");
        filtereddata[key]["checkoutdatetime"] = checkoutdatetime;
        filtereddata[key]["checkouttime"] = checkouttime;

        let lunchdiff = 0;
        if (filtereddata[key].lunchallowed) {
          lunchdiff = Math.abs(
            filtereddata[key].lunchendtimestamp -
              filtereddata[key].lunchstarttimestamp,
          );
        }

        let diff = Math.abs(checkoutdatetime - checkindatetime);
        diff = diff - lunchdiff;
        if (diff < 0) {
          diff = 0;
        }
        filtereddata[key]["minutes"] = diff / 1000 / 60;
        filtereddata[key]["edited"] = true;
        filtereddata[key]["editedby"] = user?.id;
        filtereddata[key]["manualhours"] = true;
        filtereddata[key]["bulkedit"] = true;
        filtereddata[key]["status"] = "Accepted";
        filtereddata[key]["workerstatus"] = "Checked Out";
        filtereddata[key]["editselected"] = false;
      }

      await BatchEditItem("slots", filtereddata)
        .then(async (response) => {
          if (response == "success") {
            let newdata = [...slotdata];

            for (const key in newdata) {
              let recordindex = filtereddata.findIndex((data) => {
                return data.recordid == newdata[key]?.recordid;
              });
              if (recordindex != -1) {
                newdata[key] = filtereddata[recordindex];
                newdata[key]["editselected"] = false;
              }
            }
            setslotdata(newdata);
            setbulkactionloader(false);
            setbulkeditenabled(false);
          } else {
            setbulkactionloader(false);
            toast.warn("Something went wrong. Please try again later!");
          }
        })
        .catch((error) => {
          setbulkactionloader(false);
          toast.warn("Bulk action error. Please try again later!");
        });
    } else {
      let filtereddata = slotdata.filter((item) => item.selected == true);
      let data = {
        hoursapproved: type == "cross" ? false : true,
        approvalstatusupdatedby: user.firstname + " " + user.lastname,
        approvalstatusupdatedbyid: user.id,
      };

      await BatchUpdateItem("slots", data, filtereddata)
        .then(async (response) => {
          if (response == "success") {
            let newdata = [...slotdata];
            for (const key in newdata) {
              if (newdata[key]?.selected == true) {
                newdata[key]["hoursapproved"] = data.hoursapproved;

                newdata[key]["approvalstatusupdatedby"] =
                  data.approvalstatusupdatedby;
                newdata[key]["approvalstatusupdatedbyid"] =
                  data.approvalstatusupdatedbyid;
                newdata[key]["selected"] = false;
              }
            }
            setslotdata(newdata);
            setbulkactionloader(false);
            setbulkactionsenabled(false);
          } else {
            setbulkactionloader(false);
            toast.warn("Something went wrong. Please try again later!");
          }
        })
        .catch((error) => {
          setbulkactionloader(false);
          toast.warn("Bulk action error. Please try again later!");
        });
    }
  }

  const renderavailablelist = (item, index) => {
    return (
      <div className="w-full flex flex-row justify-between items-center mb-2">
        <div
          key={index.toString()}
          className={`w-full  flex flex-row justify-between items-center border  border-bordercolor px-[10px] py-[10px] hover:cursor-pointer hover:bg-[#0989B826]/10 rounded-md  bg-themelightblack`}
        >
          <div className="w-full  flex flex-row items-center">
            <div className="relative">
              <img
                loading="lazy"
                src={item.profilepicture}
                className="w-[50px] h-[50px] object-cover rounded-full"
              />
            </div>
            <div className="ml-[20px] flex flex-col w-full">
              <div className="flex flex-row">
                <p className="PoppinsRegular  text-textcolor text-[15px]">
                  {item.firstname.toUpperCase() +
                    " " +
                    item.lastname.toUpperCase()}
                </p>
              </div>
            </div>
          </div>

          <p className="PoppinsRegular  text-textcolor text-[15px]">
            {item.phonenumber}
          </p>
        </div>
      </div>
    );
  };

  const renderavailablevehiclelist = (item, index) => {
    return (
      <div className="w-full flex flex-row justify-between items-center mb-2">
        <div
          key={index.toString()}
          className={`w-full  flex flex-row justify-between items-center border  border-bordercolor px-[10px] py-[10px] hover:cursor-pointer hover:bg-[#0989B826]/10 rounded-md bg-themelightblack`}
        >
          <div className="w-full  flex flex-row items-center">
            <div className="relative">
              <img
                loading="lazy"
                src={item.logo}
                className="w-[50px] h-[50px] object-cover rounded-full"
              />
            </div>
            <div className="ml-[20px] flex flex-col w-full">
              <div className="flex flex-col">
                <p className="PoppinsRegular  text-textcolor text-[15px]">
                  {item?.registrationnumber?.toUpperCase()}
                </p>

                <div className="flex flex-row flex-wrap">
                  {item?.slots?.map(function (inneritem, index) {
                    return (
                      <div className="bg-red-500 rounded-lg py-[5px] px-[10px] mr-[5px] mt-[5px] flex items-center justify-center">
                        <p className="PoppinsRegular  text-white text-[12px]">
                          {inneritem.timeslot}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderexpressdeliveryrequests = (item, index) => {
    return item?.expressshiftapproved ? (
      employees
        ?.filter(function (datadriver) {
          return datadriver.id == item.employeeid;
        })
        ?.map(function (datadriver) {
          return (
            <div
              onClick={() => {
                if (item?.expressshiftapproved) {
                  setselectedslot({
                    item: item,
                    recordid: item.recordid,
                    id: datadriver.id,
                    picture: datadriver.profilepicture,
                    name: datadriver.firstname + " " + datadriver.lastname,
                    designation: item.projectdesignation,
                    phonenumber: datadriver.phonenumber,
                    starttime: item?.starttime,
                    endtime: item?.endtime,
                    shifttype: item?.shifttype,
                    schedulecreationdate: item?.schedulecreationdate,
                    selecteddate: moment(selecteddate).format("YYYY-MM-DD"),
                    status: item?.status,
                  });
                  setempdetailsvisible(true);
                }
              }}
              className="w-full flex flex-row justify-between items-center mb-2"
            >
              <div
                key={index.toString()}
                className={`w-full  flex flex-col justify-between items-center border  border-bordercolor px-[10px] py-[10px] hover:cursor-pointer hover:bg-[#0989B826]/10 rounded-md bg-themelightblack`}
              >
                <div className="flex flex-row justify-between items-center w-full px-[10px]">
                  <div>
                    {employees
                      ?.filter(function (data) {
                        return data.id == item.createdby;
                      })
                      ?.map(function (data) {
                        return (
                          <div className="w-full flex flex-row justify-between items-center">
                            <div className="w-full  flex flex-row items-center">
                              <div className="flex relative justify-center">
                                <img
                                  loading="lazy"
                                  src={data.profilepicture}
                                  className="w-[50px] h-[50px] object-contain rounded-full"
                                />
                              </div>
                              <div className="ml-[10px] flex flex-col w-full">
                                <div className="flex flex-row">
                                  <p className="PoppinsRegular  text-textcolor text-[15px]">
                                    {data.firstname.toUpperCase() +
                                      " " +
                                      data.lastname.toUpperCase()}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div>
                    {!user.clientrole && item?.status == "Pending Approval" ? (
                      <button
                        onClick={() => {
                          navigate("/CreateEmployeeSchedule", {
                            state: {
                              projectid: item.projectid,
                              expressdelivery: true,
                              expressshiftdata: item,
                              shifttype: "Driver",
                            },
                          });
                        }}
                        type="submit"
                        className={`text-center w-[120px] py-2 rounded-md  bg-cardOverlay  drop-shadow-lg hover:bg-themeblue/80 bg-themeblue text-white text-sm PoppinsRegular uppercase  `}
                      >
                        Approve
                      </button>
                    ) : (
                      <p
                        className={`PoppinsRegular  text-[15px]  ${
                          item?.checkoutdatetime
                            ? "text-red-500"
                            : item?.checkindatetime
                              ? "text-textcolor"
                              : item?.status == "Pending Approval"
                                ? "text-yellow-500"
                                : " text-themegreen"
                        } `}
                      >
                        {item?.checkindatetime != undefined &&
                        item?.checkoutdatetime == undefined
                          ? item?.workerstatus +
                            " - " +
                            moment(item?.checkindatetime).format("HH:mm")
                          : item?.workerstatus}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-row justify-center items-center mt-[10px] flex-wrap w-full">
                  {item.pickupdestinations?.map((inneritem, index) => (
                    <div className="flex flex-row items-center justify-center">
                      <div
                        key={index.toString()}
                        className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg py-[10px] px-[5px] rounded-lg relative mr-[10px] min-w-[200px] max-w-[200px]"
                      >
                        <div className="h-[40px]">
                          <img
                            loading="lazy"
                            src={inneritem.projectdata.logo}
                            className="w-[40px] h-[40px] object-cover rounded-full"
                          />
                        </div>
                        <div className="flex items-center  justify-evenly flex-row mt-[10px] w-full">
                          <div className="flex items-start justify-center flex-col">
                            <p className="PoppinsRegular text-white/80 text-[10px]      text-center w-full">
                              Pick Up Date
                            </p>
                            <p className="PoppinsRegular text-white text-[10px]     text-center w-full">
                              {inneritem.pickupdate}
                            </p>
                          </div>
                          <div className="flex items-start justify-center flex-col">
                            <p className="PoppinsRegular text-white/80 text-[10px]  text-center w-full  ">
                              Pick Up Time
                            </p>
                            <p className="PoppinsRegular text-white text-[10px]      text-center w-full ">
                              {inneritem.pickuptime}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mr-[20px]">
                        <FaArrowRight className="  text-white w-[10px] h-[10px] " />
                      </div>
                    </div>
                  ))}
                  {item.dropoffdestinations?.map((inneritem, index) => (
                    <div className="flex flex-row items-center justify-center">
                      <div
                        key={index.toString()}
                        className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg py-[10px] px-[5px] rounded-lg relative mr-[10px] min-w-[200px] max-w-[200px]"
                      >
                        <div className="flex justify-center items-center  w-[80%] h-[40px]">
                          <p className="PoppinsRegular text-white text-[10px]  text-center  uppercase  w-full line-clamp-3">
                            {inneritem.destination}
                          </p>
                        </div>
                        <div className="flex items-center  justify-evenly flex-row mt-[10px] w-full">
                          <div className="flex items-start justify-center flex-col">
                            <p className="PoppinsRegular text-white/80 text-[10px]      text-center w-full ">
                              Drop Off Date
                            </p>
                            <p className="PoppinsRegular text-white text-[10px]   text-center w-full  ">
                              {inneritem.deliverydate}
                            </p>
                          </div>
                          <div className="flex items-start justify-center flex-col">
                            <p className="PoppinsRegular text-white/80 text-[10px] text-center w-full    ">
                              Drop Off Time
                            </p>
                            <p className="PoppinsRegular text-white text-[10px]  text-center w-full   ">
                              {inneritem.deliverytime}
                            </p>
                          </div>
                        </div>
                      </div>
                      {index < item.dropoffdestinations.length - 1 && (
                        <div className="mr-[20px]">
                          <FaArrowRight className="  text-white w-[10px] h-[10px] " />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })
    ) : (
      <div
        onClick={() => {}}
        className="w-full flex flex-row justify-between items-center mb-2"
      >
        <div
          key={index.toString()}
          className={`w-full  flex flex-col justify-between items-center border  border-bordercolor px-[10px] py-[10px] hover:cursor-pointer hover:bg-[#0989B826]/10 rounded-md bg-themelightblack`}
        >
          <div className="flex flex-row justify-between items-center w-full px-[10px]">
            <div>
              {employees
                ?.filter(function (data) {
                  return data.id == item.createdby;
                })
                ?.map(function (data) {
                  return (
                    <div className="w-full flex flex-row justify-between items-center">
                      <div className="w-full  flex flex-row items-center">
                        <div className="flex relative justify-center">
                          <img
                            loading="lazy"
                            src={data.profilepicture}
                            className="w-[50px] h-[50px] object-contain rounded-full"
                          />
                        </div>
                        <div className="ml-[10px] flex flex-col w-full">
                          <div className="flex flex-row">
                            <p className="PoppinsRegular  text-textcolor text-[15px]">
                              {data.firstname.toUpperCase() +
                                " " +
                                data.lastname.toUpperCase()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div>
              {!user.clientrole && item?.status == "Pending Approval" ? (
                <button
                  onClick={() => {
                    navigate("/CreateEmployeeSchedule", {
                      state: {
                        projectid: item.projectid,
                        expressdelivery: true,
                        expressshiftdata: item,
                        shifttype: "Driver",
                      },
                    });
                  }}
                  type="submit"
                  className={`text-center w-[120px] py-2 rounded-md  bg-cardOverlay  drop-shadow-lg hover:bg-themeblue/80 bg-themeblue text-white text-sm PoppinsRegular uppercase  `}
                >
                  Approve
                </button>
              ) : (
                <p
                  className={`PoppinsRegular  text-[15px]  ${
                    item?.checkoutdatetime
                      ? "text-red-500"
                      : item?.checkindatetime
                        ? "text-textcolor"
                        : item?.status == "Pending Approval"
                          ? "text-yellow-500"
                          : " text-themegreen"
                  } `}
                >
                  {item?.checkindatetime != undefined &&
                  item?.checkoutdatetime == undefined
                    ? item?.workerstatus +
                      " - " +
                      moment(item?.checkindatetime).format("HH:mm")
                    : item?.workerstatus}
                </p>
              )}
            </div>
          </div>
          <div className="flex flex-row justify-center items-center mt-[10px] flex-wrap w-full">
            {item.pickupdestinations?.map((inneritem, index) => (
              <div className="flex flex-row items-center justify-center">
                <div
                  key={index.toString()}
                  className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg py-[10px] px-[5px] rounded-lg relative mr-[10px] min-w-[200px] max-w-[200px]"
                >
                  <div className="h-[40px]">
                    <img
                      loading="lazy"
                      src={inneritem.projectdata.logo}
                      className="w-[40px] h-[40px] object-cover rounded-full"
                    />
                  </div>
                  <div className="flex items-center  justify-evenly flex-row mt-[10px] w-full">
                    <div className="flex items-start justify-center flex-col">
                      <p className="PoppinsRegular text-white/80 text-[10px]      text-center w-full">
                        Pick Up Date
                      </p>
                      <p className="PoppinsRegular text-white text-[10px]     text-center w-full">
                        {inneritem.pickupdate}
                      </p>
                    </div>
                    <div className="flex items-start justify-center flex-col">
                      <p className="PoppinsRegular text-white/80 text-[10px]  text-center w-full  ">
                        Pick Up Time
                      </p>
                      <p className="PoppinsRegular text-white text-[10px]      text-center w-full ">
                        {inneritem.pickuptime}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mr-[20px]">
                  <FaArrowRight className="  text-white w-[10px] h-[10px] " />
                </div>
              </div>
            ))}
            {item.dropoffdestinations?.map((inneritem, index) => (
              <div className="flex flex-row items-center justify-center">
                <div
                  key={index.toString()}
                  className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg py-[10px] px-[5px] rounded-lg relative mr-[10px] min-w-[200px] max-w-[200px]"
                >
                  <div className="flex justify-center items-center  w-[80%] h-[40px]">
                    <p className="PoppinsRegular text-white text-[10px]  text-center  uppercase  w-full line-clamp-3">
                      {inneritem.destination}
                    </p>
                  </div>
                  <div className="flex items-center  justify-evenly flex-row mt-[10px] w-full">
                    <div className="flex items-start justify-center flex-col">
                      <p className="PoppinsRegular text-white/80 text-[10px]      text-center w-full ">
                        Drop Off Date
                      </p>
                      <p className="PoppinsRegular text-white text-[10px]   text-center w-full  ">
                        {inneritem.deliverydate}
                      </p>
                    </div>
                    <div className="flex items-start justify-center flex-col">
                      <p className="PoppinsRegular text-white/80 text-[10px] text-center w-full    ">
                        Drop Off Time
                      </p>
                      <p className="PoppinsRegular text-white text-[10px]  text-center w-full   ">
                        {inneritem.deliverytime}
                      </p>
                    </div>
                  </div>
                </div>
                {index < item.dropoffdestinations.length - 1 && (
                  <div className="mr-[20px]">
                    <FaArrowRight className="  text-white w-[10px] h-[10px] " />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const manualhourapprovedsuccess = async (
    employeeid,
    shiftid,
    message,
    bool,
  ) => {
    try {
      const res = await fetch(
        "https://us-central1-raftekpro-82bb0.cloudfunctions.net/api/newnotificationshiftapproval",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: employeeid,
            message: message,
            shiftid: shiftid,
            bool: bool,
          }),
        },
      );
      if (res.status == 200) {
        console.log("Notififcation " + JSON.stringify(res));
        const data = await res.json();
        console.log(data);
        console.log("Successfully Notified User");
      } else {
        console.log(res);
        console.log("Notififcation Error" + JSON.stringify(res));
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="w-[100%] lg:flex  items-center  flex-col  mt-[70px] md:mt-[0px] ">
      {selectedprojectdata !== "" ? (
        <img
          loading="lazy"
          src={selectedprojectdata.logo}
          className="w-full h-[300px] rounded-md object-cover"
        />
      ) : (
        <div className="w-full min-h-[300px] rounded-md  bg-themelightblack  bg-cardOverlay  drop-shadow-lg flex items-center justify-center">
          <p className="PoppinsRegular  text-white text-[25px]">Projects</p>
        </div>
      )}
      <div className="w-full flex justify-start mt-[10px]">{todaysdate()}</div>

      <div className="flex flex-row items-center w-full justify-center mt-[40px]">
        <p
          onClick={() => {
            setselectedshifttype("Worker");
          }}
          className={`PoppinsRegular text-[14px]   hover:cursor-pointer hover:underline  ${
            selectedshifttype == "Worker"
              ? "text-textcolor  text-[15px]"
              : "text-textcolor"
          }`}
        >
          Worker Shifts
        </p>
        <p className="mx-[10px]">|</p>
        <p
          onClick={() => {
            setselectedshifttype("Cleaner");
          }}
          className={`PoppinsRegular text-[14px]   hover:cursor-pointer hover:underline  ${
            selectedshifttype == "Cleaner"
              ? "text-textcolor  text-[15px]"
              : "text-textcolor"
          } `}
        >
          Cleaner Shifts
        </p>
      </div>

      <div className="flex flex-col md:flex-row w-full justify-evenly mt-[20px] md:mt-[40px] ">
        {filters("Projects", selectedproject, () => {
          setprojectpopup(!projectpopup);
        })}

        {selecteddesignations.length > 0 &&
          selectedstatus != "Available Vehicles" &&
          selectedstatus != "Available" &&
          filters("Designations", selecteddesignations, () => {
            setdesignationselectionpopup(!designationselectionpopup);
          })}

        {selectedshifttype == "Worker" &&
          filters("Status", selectedstatus, () => {
            setstatuspopup(!statuspopup);
          })}
      </div>

      {selectedshifttype == "Worker" && (
        <div className="w-full pt-[20px]">
          {/* <DatePicker getSelectedDay={selectedDay}
                  selectDate={selecteddate}
                  endDate={180}
                  enableScroll={true}
                  startingDate = {new Date(2023, 0, 1)}
                  // startDate={180}
                  // selectedDate={selecteddate}
                  // startDate={new Date(2023, 0, 1)}
                  // endDate={new Date(31, 12, 2024)}
                  labelFormat={"MMMM yyyy"}
                  color={"#1F2E5E"}

/> */}

          <HorizontalDatePicker
            startDate={startdate}
            endDate={enddate}
            selectedDate={selecteddate}
            onDateSelected={selectedDay}
          />

          <div className="flex flex-row w-full justify-end items-center">
            {bulkactionloader ? (
              <div className="px-[15px]">
                <RotatingLines
                  visible={true}
                  height="25"
                  width="25"
                  strokeColor="#00C763"
                  color="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              user.bulkeditaccess &&
              selectedstatus != "Available Vehicles" &&
              selectedstatus != "Express Delivery" && (
                <div className="flex flex-row w-full justify-end items-center">
                  <button
                    onClick={() => {
                      setbulkactionsenabled(!bulkactionsenabled);
                      setbulkeditenabled(false);
                      // navigate('/CreateEmployeeSchedule', {
                      //   state: {
                      //     projectid: item.projectid,
                      //     cleanershiftedit: true,
                      //     cleaningshiftdata: item
                      //   }
                      // });
                    }}
                    type="submit"
                    className={`text-center w-[120px] py-2 rounded-md  bg-cardOverlay  drop-shadow-lg hover:bg-themeblue/80 ${
                      bulkactionsenabled
                        ? "bg-themeblue"
                        : " bg-themelightblack "
                    }  text-white text-sm PoppinsRegular uppercase  `}
                  >
                    Bulk Approve
                  </button>
                  <button
                    onClick={() => {
                      setbulkeditenabled(!bulkeditenabled);
                      setbulkactionsenabled(false);
                      // navigate('/CreateEmployeeSchedule', {
                      //   state: {
                      //     projectid: item.projectid,
                      //     cleanershiftedit: true,
                      //     cleaningshiftdata: item
                      //   }
                      // });
                    }}
                    type="submit"
                    className={`ml-[5px] text-center w-[120px] py-2 rounded-md  bg-cardOverlay  drop-shadow-lg hover:bg-themeblue/80 ${
                      bulkeditenabled ? "bg-themeblue" : " bg-themelightblack "
                    }  text-white text-sm PoppinsRegular uppercase  `}
                  >
                    Bulk Edit
                  </button>
                  {slotdata?.find((data) => data.selected == true) !=
                    undefined &&
                    bulkactionsenabled && (
                      <div className="flex flex-row ">
                        <button
                          onClick={() => {
                            bulkaction("check");
                          }}
                          type="submit"
                          className={`ml-[5px] text-center w-[120px] py-2 rounded-md  hover:bg-themeblue  text-textcolor hover:text-white text-sm PoppinsRegular uppercase  bg-themelightblack drop-shadow-lg`}
                        >
                          Approve All
                        </button>
                        <button
                          onClick={() => {
                            bulkaction("cross");
                          }}
                          type="submit"
                          className={`ml-[5px] text-center w-[120px] py-2 rounded-md  hover:bg-red-500  text-textcolor hover:text-white text-sm PoppinsRegular uppercase bg-themelightblack drop-shadow-lg `}
                        >
                          Reject All
                        </button>
                      </div>
                    )}

                  {slotdata?.find((data) => data.editselected == true) !=
                    undefined &&
                    bulkeditenabled && (
                      <div className="flex flex-row ">
                        <button
                          onClick={() => {
                            bulkaction("reset");
                          }}
                          type="submit"
                          className={`ml-[5px] text-center w-[120px] py-2 rounded-md  hover:bg-themeblue  text-textcolor hover:text-white text-sm PoppinsRegular uppercase  bg-themelightblack drop-shadow-lg`}
                        >
                          Reset Shift
                        </button>
                        <button
                          onClick={() => {
                            navigate("/UpdateSlot", {
                              state: {
                                bulkedit: true,
                                bulkdata: slotdata.filter(
                                  (item) => item.editselected == true,
                                ),
                              },
                            });
                          }}
                          type="submit"
                          className={`ml-[5px] text-center w-[120px] py-2 rounded-md  hover:bg-yellow-500  text-textcolor hover:text-white text-sm PoppinsRegular uppercase bg-themelightblack drop-shadow-lg `}
                        >
                          Edit All
                        </button>
                      </div>
                    )}
                </div>
              )
            )}
          </div>
        </div>
      )}

      <div className="w-full py-[20px] flex flex-col items-center justify-center">
        {loading ? (
          <div className="py-[80px]">
            <RotatingLines
              visible={true}
              height="25"
              width="25"
              strokeColor="#00C763"
              color="grey"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (selectedstatus == "Available" && availableemployees.length == 0) ||
          (selectedstatus == "Available Vehicles" &&
            allavailablevehicles.length == 0) ||
          (selectedstatus != "Available" &&
            selectedstatus != "Available Vehicles" &&
            slotdata.length == 0) ? (
          <div className="flex flex-col w-full py-[80px] items-center justify-center">
            <p className="PoppinsRegular  text-textcolor ">
              {selectedshifttype == "Worker"
                ? "No Slots Avaialble"
                : "No Cleaner Shifts Available"}
            </p>
            <ImFilesEmpty className="text-[40px] text-textcolor pt-[5px]" />
          </div>
        ) : selectedshifttype == "Worker" ? (
          selectedstatus == "Available" ? (
            availableemployees.map((item, index) =>
              renderavailablelist(item, index),
            )
          ) : selectedstatus == "Available Vehicles" ? (
            allavailablevehicles.map((item, index) =>
              renderavailablevehiclelist(item, index),
            )
          ) : selectedstatus == "Express Delivery" ? (
            slotdata.map((item, index) =>
              renderexpressdeliveryrequests(item, index),
            )
          ) : (
            slotdata.map((item, index) => {
              const checkout = new Date(item.checkoutdatetime);
              const endtime = new Date(item.endtimetimestamp);
              const endtimePlusTwoMinutes = new Date(
                endtime.getTime() + 3 * 60 * 1000,
              );
              const latecheckout = checkout > endtimePlusTwoMinutes;
              const nocheckincheckout =
                item?.checkindatetime == undefined &&
                item?.checkoutdatetime == undefined &&
                Date.now() > item.endtimetimestamp;

              return (
                // item.status == "Accepted" &&
                (item.workerstatus == selectedstatus ||
                  selectedstatus == "All" ||
                  (selectedstatus == "Not Accepted" &&
                    item.status != "Accepted")) &&
                (selecteddesignations.find((data) => data.selected == true) ==
                  undefined ||
                  selecteddesignations.find(
                    (data) =>
                      data.selected == true &&
                      item.projectdesignation == data.designation,
                  ) != undefined) &&
                employees
                  .filter(function (data) {
                    return data.id == item.employeeid;
                  })
                  .map(function (data) {
                    return (
                      <div className="w-full flex flex-row justify-between items-center">
                        {bulkactionsenabled && (
                          <div className="w-[25px]">
                            {item?.hoursapproved != true &&
                              item?.checkindatetime != undefined &&
                              item?.checkoutdatetime != undefined && (
                                <div
                                  className=""
                                  onClick={() => {
                                    let newdata = [...slotdata];
                                    newdata[index]["selected"] =
                                      !newdata[index]["selected"];
                                    setslotdata(newdata);
                                  }}
                                >
                                  {item?.selected ? (
                                    <IoCheckbox className="text-[20px] text-textcolor cursor-pointer" />
                                  ) : (
                                    <IoCheckboxOutline className="text-[20px] text-bordercolor cursor-pointer " />
                                  )}
                                </div>
                              )}
                          </div>
                        )}

                        {bulkeditenabled && (
                          <div className="w-[25px]">
                            {item?.hoursapproved != true && (
                              <div
                                className=""
                                onClick={() => {
                                  let newdata = [...slotdata];
                                  newdata[index]["editselected"] =
                                    !newdata[index]["editselected"];
                                  setslotdata(newdata);
                                }}
                              >
                                {item?.editselected ? (
                                  <IoCheckbox className="text-[20px] text-textcolor cursor-pointer" />
                                ) : (
                                  <IoCheckboxOutline className="text-[20px] text-bordercolor cursor-pointer " />
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        <div
                          key={index.toString()}
                          onClick={() => {
                            setselectedslot({
                              item: item,
                              recordid: item.recordid,
                              id: data.id,
                              picture: data.profilepicture,
                              name: data.firstname + " " + data.lastname,
                              designation: item.projectdesignation,
                              phonenumber: data.phonenumber,
                              starttime: item?.starttime,
                              endtime: item?.endtime,
                              shifttype: item?.shifttype,
                              schedulecreationdate: item?.schedulecreationdate,
                              selecteddate:
                                moment(selecteddate).format("YYYY-MM-DD"),
                              status: item?.status,
                            });
                            setempdetailsvisible(true);
                          }}
                          className={`w-full  flex flex-row justify-between items-center border border-bordercolor px-[10px] py-[10px] hover:cursor-pointer hover:bg-[#0989B826]/10 rounded-md mt-1  ${
                            nocheckincheckout
                              ? "bg-[rgba(255,0,0,0.5)]"
                              : item?.hoursapproved != false &&
                                  item?.late != true &&
                                  latecheckout != true
                                ? " bg-themelightblack"
                                : "bg-red-400"
                          }`}
                        >
                          <div className="w-full  flex flex-row items-center">
                            <div className="flex relative justify-center">
                              <img
                                loading="lazy"
                                src={data.profilepicture}
                                className="w-[50px] h-[50px] object-cover rounded-full"
                              />

                              {item?.shifttype == "Driver" && (
                                <div className="position absolute bottom-[-5px]  h-[20px] w-[60px] rounded-full bg-themeblue flex items-center justify-center">
                                  <p className="PoppinsRegular  text-white text-[10px]">
                                    {item?.vehiclenumber}
                                  </p>
                                </div>
                              )}
                              {item?.hoursapproved != "noaction" && (
                                <div
                                  className={`position absolute bottom-[-2px] right-[-5px] h-[20px] w-[20px] rounded-full ${
                                    item?.hoursapproved == true ||
                                    item?.hoursapproved == false
                                      ? "bg-white"
                                      : ""
                                  } flex items-center justify-center`}
                                >
                                  {item?.hoursapproved == true && (
                                    <IoMdCheckmark className="text-themegreen" />
                                  )}
                                  {item?.hoursapproved == false && (
                                    <RxCross2 className="text-red-500" />
                                  )}
                                </div>
                              )}
                            </div>
                            <div className="ml-[20px] flex flex-col w-full">
                              <div className="flex flex-row">
                                {item?.expressdelivery && (
                                  <div className=" rounded-full bg-red-700 flex items-center justify-center w-[140px] mr-[10px]">
                                    <p className="PoppinsRegular  text-white text-[15px] ">
                                      {"Express Delivery"}
                                    </p>
                                  </div>
                                )}
                                <p className="PoppinsRegular  text-textcolor text-[15px]">
                                  {data.firstname.toUpperCase() +
                                    " " +
                                    data.lastname.toUpperCase() +
                                    " as  "}
                                </p>
                                <p className="PoppinsRegular  text-textcolor ml-[5px] text-[15px]">
                                  {item.projectdesignation}
                                </p>
                                <p className="PoppinsRegular  text-textcolor ml-[5px] text-[15px]">
                                  {item?.tasks?.length > 0
                                    ? "(" + item?.tasks.length + " Tasks)"
                                    : ""}
                                </p>
                                {item?.manualhours == true && (
                                  <div className="bg-themeblue rounded-full px-[10px] ml-[5px] flex justify-center items-center ">
                                    <p className="PoppinsRegular  text-textcolor text-[12px]">
                                      Manual
                                    </p>
                                  </div>
                                )}
                              </div>

                              {item.status != "Accepted" ? (
                                <p
                                  className={`PoppinsRegular  text-[15px]  text-yellow-500 `}
                                >
                                  {"Pending Acceptance"}
                                </p>
                              ) : (
                                <p
                                  className={`PoppinsRegular  text-[15px] ${
                                    item?.checkoutdatetime
                                      ? "text-red-500"
                                      : item?.checkindatetime
                                        ? "text-textcolor"
                                        : "text-orange-500"
                                  } `}
                                >
                                  {item?.checkindatetime != undefined &&
                                  item?.checkoutdatetime == undefined
                                    ? item?.workerstatus +
                                      " - " +
                                      moment(item?.checkindatetime).format(
                                        "HH:mm",
                                      )
                                    : item?.workerstatus}
                                </p>
                              )}
                              <p
                                className={`PoppinsRegular  ${
                                  item?.checkoutdatetime
                                    ? "text-themegreen"
                                    : "text-lighttextGray"
                                }  text-[15px]`}
                              >
                                {item?.checkoutdatetime
                                  ? moment(item?.checkindatetime).format(
                                      "HH:mm",
                                    ) +
                                    " - " +
                                    moment(item?.checkoutdatetime).format(
                                      "HH:mm",
                                    )
                                  : item.timeslot}
                              </p>
                            </div>
                          </div>

                          <IoIosArrowForward className="text-[20px] text-lightgrey" />
                        </div>
                      </div>
                    );
                  })
              );
            })
          )
        ) : (
          <table className="  w-[90%]  divide-y divide-bordercolor text-sm mt-[20px]   px-3 lg:px-7">
            <thead className="ltr:text-left rtl:text-right">
              <tr>
                <th className="whitespace-nowrap py-2  PoppinsRegular text-textcolor px-4 ">
                  Date
                </th>
                <th className="whitespace-nowrap py-2  PoppinsRegular text-textcolor px-4 ">
                  Time Slot
                </th>
                <th className="whitespace-nowrap py-2  PoppinsRegular text-textcolor px-4 ">
                  No Of Employees
                </th>
                <th className="whitespace-nowrap py-2  PoppinsRegular text-textcolor px-4 ">
                  Designation
                </th>
                <th className="whitespace-nowrap py-2  PoppinsRegular text-textcolor px-4 "></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-bordercolor text-center">
              {slotdata.map(
                (item, index) =>
                  (selecteddesignations.find((data) => data.selected == true) ==
                    undefined ||
                    selecteddesignations.find(
                      (data) =>
                        data.selected == true &&
                        item.projectdesignation == data.designation,
                    ) != undefined) && (
                    <tr
                      key={index.toString()}
                      className="hover:bg-[#0989B826]/10 cursor-pointer "
                    >
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item.startdate + " - " + item.enddate}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item.timeslot}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item?.employees?.length}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                        {item.projectdesignation}
                      </td>
                      <td className="px-[15px] mr-[30px] py-2">
                        <button
                          onClick={() => {
                            navigate("/CreateEmployeeSchedule", {
                              state: {
                                projectid: item.projectid,
                                cleanershiftedit: true,
                                cleaningshiftdata: item,
                              },
                            });
                          }}
                          type="submit"
                          className="text-center w-[120px] py-2 rounded-md bg-themeblue text-white text-sm PoppinsRegular uppercase  "
                        >
                          Add Employee
                        </button>
                      </td>
                    </tr>
                  ),
              )}
            </tbody>
          </table>
        )}
      </div>

      <EmployeeSlotPopUp
        visible={empdetailsvisible}
        data={selectedslot}
        activateoutsidecontainerclick={() => {
          setempdetailsvisible(false);
        }}
        onapprovalsuccess={(id, bool) => {
          let allempdata = [...slotdata];
          let empindex = allempdata.findIndex((data) => {
            return data.recordid == id;
          });
          allempdata[empindex]["hoursapproved"] = bool;

          setslotdata(allempdata);
        }}
        onmanualhourapprovedsuccess={(employeeid, shiftid, message, bool) => {
          manualhourapprovedsuccess(employeeid, shiftid, message, bool);
        }}
        filtertasks={(id, tasks) => {
          let allempdata = [...slotdata];
          let empindex = allempdata.findIndex((data) => {
            return data.recordid == id;
          });
          allempdata[empindex].tasks = tasks;
          setslotdata(allempdata);
        }}
      />
    </div>
  );
};

export default Slots;
